import React from 'react';
const links = ['Terms of Service', 'Privacy Policy', 'Refund Policy', 'Contact'];
export function Footer() {
  return <footer className="w-full bg-white px-5 py-12" data-id="element-99" data-mp="3gg10u7y865zr">
      <div className="mx-auto max-w-5xl text-center" data-id="element-100" data-mp="32num8qaq072f">
        <p className="font-display text-xl font-black uppercase tracking-tight text-ink" data-id="element-101" data-mp="32pffmclatjyp">
          Physics &amp; Chemistry Ready-to-Teach™
        </p>
        <nav aria-label="Footer" data-id="element-102" data-mp="3ufa5qbgzddof">
          <ul className="mt-5 flex flex-wrap items-center justify-center gap-x-6 gap-y-3 text-xs font-semibold text-ink/55" data-id="element-103" data-mp="3ugbshd7czolz">
            {links.map(link => <li key={link} data-id="element-104" data-mp="3lem0a55nkln5">
                <a href="#offer" className="transition-colors hover:text-cta-dark" data-id="element-105" data-mp="3ldaobi2207ky">
                  {link}
                </a>
              </li>)}
          </ul>
        </nav>
        <p className="mx-auto mt-7 max-w-2xl text-[11px] leading-relaxed text-ink/40" data-id="element-106" data-mp="29yxcjbkkrila">
          © 2026 Physics &amp; Chemistry Ready-to-Teach™. All rights reserved.
        </p>
      </div>
    </footer>;
}